export const addProductHistory = (productId: number) => {
    let list = getProductHistory()
    list.unshift(productId)
    const set = new Set(list)
    const nList = Array.from(set)
    const listString = nList.join()
    localStorage.setItem('carharttProductHistory', listString)
}

export const getProductHistory = () => {
    const listString = localStorage.getItem('carharttProductHistory') || ''
    const list = listString.split(',')
    let nList: number[] = []
    list.forEach((item, index) => {
        if (item && index < 24) nList.push(parseInt(item));
    })
    return nList
}
